import { WidgetSchema } from 'features/views/LayoutEditor/types'
import {
    getRequiredFieldsFromField,
    getRequiredFieldsFromFilters,
} from 'features/views/LayoutEditor/utils'

import { HighlightsWidget } from './HighlightsWidget'
import { HighlightsWidgetAdminControls } from './HighlightsWidgetAdminControls'
import { HighlightsWidgetType } from './types'

export const HighlightsWidgetMeta: WidgetSchema<HighlightsWidgetType> = {
    category: 'data',
    label: 'Highlights',
    icon: 'Star',
    component: HighlightsWidget,
    adminControlsComponent: HighlightsWidgetAdminControls,
    defaultAttrs: {
        items: [],
        showItemLabel: true,
        showItemIcon: true,
        style: 'minimal',
    },
    requireFields: (attrs, fields) => {
        return attrs.items.flatMap((f) => {
            const field = fields?.get(f.sid)
            if (!field) return []

            const requiredFields = getRequiredFieldsFromField(field)
            const requiredFieldsForConditions = getRequiredFieldsFromFilters(f.conditions, fields)

            return [...requiredFields, ...requiredFieldsForConditions]
        })
    },
}
